import { Table } from "antd";
import { QuotationClient } from "../../../../../../../../../../../shared/interfaces";
import { ActionButton } from "@hdi-seguros/web-components.action-button";
import { DeleteOutlined } from "@ant-design/icons";
import { useContext, useState } from "react";
import { StepOneFormContext } from "../../../../../../contexts";

export const LoadedReprensentantsList = () => {
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(5);
  const {
    setLegalRepresentativeSelected,
    legalRepresentativeSelected,
  } = useContext(StepOneFormContext);

    const handleDeleteLoadedRepresentant = (index: number) => {
        const updated = [...legalRepresentativeSelected!];
        updated.splice(index, 1);
        setLegalRepresentativeSelected(updated);
    };

    const columns = [
        {
            title: 'Apellido y Nombre',
            dataIndex: 'peNomb',
            key: 'peNomb',
            width: 200,
        },
        {
            title: 'Tipo de Documento',
            dataIndex: 'petido',
            key: 'petido',
            width: 150,
        },
        {
            title: 'Número de Documento',
            dataIndex: 'peNdni',
            key: 'peNdni',
            width: 150,
        },
        {
            title: 'Eliminar',
            key: 'delete',
            width: 1,
            render: (index:number) => (
                <ActionButton
                  className='btn-accent-outline-barbuss'
                  type='secondary'
                  label='Eliminar'
                  icon={<DeleteOutlined />}
                  onClick={() => handleDeleteLoadedRepresentant(index)}
                />
              ),
        },
    ];

    return (
        <Table
          bordered
          className='w-100'
          columns={columns}
          dataSource={legalRepresentativeSelected}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: legalRepresentativeSelected?.length,
            showTotal: (total) =>
              total === 1 ? 'Un representante' : `${total} representantes`,
            showSizeChanger: false,
            onChange: (page, pageSize) => {
              setCurrentPage(page);
              setPageSize(pageSize);
            },
        }}
          scroll={{ x: 'max-content' }}
        />
    );
}